import React from 'react';
import {View} from 'react-native';

import ClientsOverviewSection from '/component/screen/Clients/ClientsOverviewSection';
import ExpiringSection from '/component/screen/Clients/ExpiringSection';
import CoachesSection from '/component/screen/Teams/CoachesSection';
import TeamsOverviewSection from '/component/screen/Teams/TeamsOverviewSection';
import {DASHBOARD_SCREEN} from '/enum/screen.enum';

import {getIsBusinessLeader} from '../Dashboard.util';

import {styles} from './HomeMetrics.style';
import {HomeMetricsProps} from './HomeMetrics.types';
import {Loading} from './Loading';

export const HomeMetrics = ({
  onShowReport = () => {},
  onShowInfoPopover = () => {},
  hasHomeMetricsById = false,
  currentUserCompetency = '',
}: HomeMetricsProps) => {
  const {isBusinessLeader, isBusinessLeaderOrBusinessCoach} =
    getIsBusinessLeader(currentUserCompetency);

  const сlientsOverviewSection = () => (
    <ClientsOverviewSection
      onShowReport={onShowReport}
      onShowInfoPopover={onShowInfoPopover}
      screenName={DASHBOARD_SCREEN}
    />
  );

  const teamsOverviewSection = () => (
    <>
      <CoachesSection
        onShowReport={onShowReport}
        onShowInfoPopover={onShowInfoPopover}
        screenName={DASHBOARD_SCREEN}
      />
      <TeamsOverviewSection
        onShowReport={onShowReport}
        onShowInfoPopover={onShowInfoPopover}
        screenName={DASHBOARD_SCREEN}
      />
    </>
  );

  const expiringSection = () => (
    <ExpiringSection
      onShowReport={onShowReport}
      onShowInfoPopover={onShowInfoPopover}
      screenName={DASHBOARD_SCREEN}
    />
  );

  return hasHomeMetricsById ? (
    <View style={styles.sectionOpaque}>
      {!isBusinessLeader && сlientsOverviewSection()}
      {isBusinessLeaderOrBusinessCoach && teamsOverviewSection()}
      {!isBusinessLeader && expiringSection()}
    </View>
  ) : (
    <Loading />
  );
};
